import { Toast } from "@prequel/shared-components";

import { useToast } from "@/providers/ToastProvider";

const MAX_VISIBLE_TOASTS = 3;

const Toaster = () => {
  const { toasts, dismissToast } = useToast();
  const visibleToasts = toasts.slice(-MAX_VISIBLE_TOASTS);

  if (!visibleToasts.length) {
    return null;
  }

  return (
    <div className="fixed right-0 bottom-0 z-20 w-1/3 space-y-2 p-5">
      {visibleToasts.map((toast) => (
        <div key={toast.id} className="duration-300">
          <Toast toast={toast} dismissHandler={dismissToast} />
        </div>
      ))}
    </div>
  );
};

export default Toaster;
